import { OrderStatus } from './order-status';

export default class OrderSaleState {
    public OrderId: number = 0;
    public Status: OrderStatus = OrderStatus.Reserved;
}